export function isObject(a: unknown): a is AnyObject {
	return typeof a === 'object' && a !== null && !Array.isArray(a);
}

export function getObjectProperty(obj: AnyObject, path: string[]): unknown {
	return path.reduce((o, p) => o?.[p], obj);
}
